// import type { GetServerSidePropsContext, GetServerSidePropsResult } from 'next'
// import { getToken as getNextAuthToken } from 'next-auth/jwt'

export const TOKEN_KEY = '@SwileCorporates:Token'

export function getToken() {
  if (typeof window !== 'undefined') {
    const token = localStorage.getItem(TOKEN_KEY)
    return token
  }

  return false
}

export function setToken(token: string) {
  localStorage.setItem(TOKEN_KEY, token)
}

// type TWithPermissionDefault = {
//   /** Permissions that user can be to access the route. */
//   permissions: string[]
// }

// type TWithCallback<T> = {
//   callback: (
//     args: {
//       context: GetServerSidePropsContext
//     } & TWithPermissionDefault
//   ) => Promise<GetServerSidePropsResult<T>>
// } & TWithPermissionDefault

// type TWithoutCallback = {
//   callback?: undefined
// } & TWithPermissionDefault

// type TWithPermission<T> = TWithoutCallback | TWithCallback<T>

/**
 * NOTE: This function only runs on Server Side.
 * @example
 * // Only permissions
 * export const getServerSideProps = withPermission({
 *  permissions: ['manage swile-credit']
 * })
 * @example
 * // With callback
 * export const getServerSideProps = withPermission({
 *  permissions: ['manage swile-credit'],
 *  callback: async ({ context, permissions }) => {
 *    // perform any action
 *    return {
 *      props: {
 *        // any content
 *      }
 *    }
 *  }
 * })
 */
// export function withPermission<T = Record<string, never>>(
//   args: TWithPermission<T>
// ) {
//   return async (
//     context: GetServerSidePropsContext
//   ): Promise<GetServerSidePropsResult<unknown | T>> => {
//     const token = (await getNextAuthToken({
//       req: context.req
//     })) as Model.Account

//     const isAllowed =
//       args.permissions.length > 0
//         ? args.permissions.some((value) => token.permissions?.includes(value))
//         : true

//     if (!isAllowed) {
//       return {
//         redirect: {
//           destination: '/',
//           permanent: false
//         }
//       }
//     }

//     if (!args.callback) {
//       return {
//         props: {}
//       }
//     }

//     return args.callback({
//       context,
//       permissions: args.permissions
//     })
//   }
// }
